<div bdFxLayout="row wrap" class="ps-container">
    <div bdFxLayoutAlign="center center" class="ps-label" [ngClass]="{'ps-error': (!inputValid && value !== null)  || (value !== null &&value.toString().length < 4) }" *ngIf="label">
        {{label}}</div>


    <div bdFxFlex="1 1 100%" class="ps-input-container" >

        <input class="ps-value" name="zip" maxlength="5" minlength="4"  [ngClass]="{'ps-error': (!inputValid && value !== null)  || (value !== null &&value.toString().length < 4) }" required  #zip="ngModel"
               [(ngModel)]="value" [placeholder]="placeholder || ''"
               (ngModelChange)="updateChanges()"
               (blur)="onBlur()"/>
    </div>
</div>
